<template>
  <div class="coop-c-hero coop-c-hero--squircle">
    <div class="coop-c-hero__inner coop-u-clearfix">
      <h1 class="coop-c-hero__title coop-u-padding-resp-t-32-24">
        Hello
      </h1>
      <div class="coop-c-hero__body">
        <p>
          We want your retirement to be a time of fulfilment and worry-free living. Answer
          7 questions to get your retirement checklist, suggested steps and guides which
          could help you plan for retirement and later life. We will not store any of this
          information and data.
        </p>
        <p>
          We do not give advice or recommendations on retirement planning, pensions, or
          investments. If this is needed it is best to contact your provider or an independent
          financial adviser.
        </p>
        <div class="coop-u-margin-t-64">
          <button
            class="coop-btn coop-btn--primary"
            @click.prevent="surveyStore.nextStep()"
          >
            Start
          </button>
        </div>
      </div>
    </div>
    <div
      class="coop-c-hero__decoration coop-c-hero__decoration--right"
      aria-hidden="true"
    >
      <svg viewBox="0 0 246 302">
        <path
          d="M16.4112 -44.1113C43.1324 -85.0645 109.935 -101.039 161.345 -85.9358C213.044 -70.8325 249.641 -24.9418 293.499 16.0114C337.647 57.255 389.056 93.8515 400.093 141.485C411.42 189.118 382.085 247.789 337.937 276.834C293.789 305.878 235.119 305.007 185.742 295.422C136.657 286.128 96.5749 268.12 69.8536 239.075C42.842 210.321 28.9005 170.239 15.5398 117.087C2.17924 63.9353 -10.6005 -2.86768 16.4112 -44.1113Z"
          fill="#84EBF9"
        />
      </svg>
    </div>
    <div
      class="coop-c-hero__decoration coop-c-hero__decoration--left"
      aria-hidden="true"
    >
      <svg
        width="66"
        height="227"
        viewBox="0 0 66 227"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M-255.566 40.3585C-233.348 6.30694 -177.803 -6.97556 -135.058 5.58245C-92.0709 18.1404 -61.6419 56.2974 -25.1754 90.3489C11.5326 124.642 54.2781 155.071 63.4551 194.677C72.8736 234.283 48.4821 283.066 11.7741 307.216C-24.9339 331.366 -73.7169 330.641 -114.772 322.672C-155.585 314.944 -188.912 299.971 -211.13 275.821C-233.59 251.912 -245.182 218.585 -256.291 174.391C-267.4 130.196 -278.026 74.6515 -255.566 40.3585Z"
          fill="#84EBF9"
        />
      </svg>
    </div>
  </div>
</template>

<script setup>
// eslint-disable-next-line import/no-unresolved
import { useSurveyStore } from '@/stores/survey.js';

const surveyStore = useSurveyStore();
</script>
